import { createSlice } from '@reduxjs/toolkit';
import * as AllAction from '../action';
import { TaskType } from '../type';
import { enumTranslator } from '@/utils';
const initialState: any = {
  vehicleName: '',
  taskType: TaskType.NOTASK,
  order: [],
  scheduleStartTime: null,
};

const orderState = createSlice({
  name: 'order',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      AllAction.actionFetchScheduleOrder,
      (state, action: any) => {
        const response = action.payload;
        const { taskType, vehicleName, order, scheduleStartTime } =
          response.data;
        state.taskType = taskType;
        state.vehicleName = vehicleName;
        state.scheduleStartTime = scheduleStartTime;

        if (order === undefined || order === null) {
          state.order = [];
        } else {
          state.order = order.map((orderItem: any) => {
            return {
              ...orderItem,
              gridNoList: orderItem.gridNoList || [],
              deliveryState:
                orderItem &&
                orderItem.deliveryState &&
                enumTranslator('DELIVERY_STATUS_ENUM', orderItem.deliveryState),
            };
          });
        }
      },
    );
  },
});

export default orderState.reducer;
